<div id="getRoamingCommunityMembers" class="table-header margin-top-30">
  <span>CommunityMembers</span>
  <div class="table-filter">
    <form class="form-inline">
      <select id="table-community-member-search"
              [(ngModel)]="optionCommunityMemberSearch"
              name="optionCommunityMemberSearch"
              class="table-filter-search form-control"
              (change)='onOptionCommunityMemberSearchChanged($event)'>
        <option selected="selected">Search Type</option>
        <option>NetID</option>
        <option>Name</option>
      </select>
      <input type="text"
             class="form-control"
             id="input-community-search"
             name="inputKeywordCommunityMemberSearch"
             [(ngModel)]="inputKeywordCommunityMemberSearch"
             aria-describedby="search"
             placeholder="Search"
             (keyup)="onKeywordSearch($event)">
      <i class="fa fa-search text-tooltip"
         aria-hidden="true" title-popup="Search" (click)="refreshCommunityMembers()">
      </i>
    </form>
  </div>
  <div class="position-relative table-icon action">
    <i class="fa fa-list transition text-tooltip"
       aria-hidden="true"
       title-popup="List">
    </i>
    <div class="tooltip-actions width-140">
      <div class="arrow-up"></div>
      <ul>
        <li>
          <label col-id="0"
                 table-name="community-members-list"
                 class="checked">NetID
          </label>
        </li>
        <li>
          <label col-id="1"
                 table-name="community-members-list"
                 class="checked">Name
          </label>
        </li>
      </ul>
    </div>
  </div>
  <div class="table-icon refresh"
       (click)="refreshCommunityMembers()">
    <i class="text-tooltip"
       [ngClass]="(communityMembersRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'" aria-hidden="true" title-popup="Refresh"></i>
  </div>
  <div *ngIf="isAdmin && canAddCommunityMember" class="table-icon plus">
    <i class="fa fa-plus transition text-tooltip"
       (click)=createCommunityMembershipPage(name,virtId,protocolVersion,createRCM)
       aria-hidden="true"
       title-popup="Add"></i>
  </div>
</div>
<table class="table table-striped"
       id="community-members-list">
  <thead>
  <tr>
    <th>NetIDs</th>
    <th>Name</th>
    <th *ngIf="isAdmin"></th>
  </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listCommunityMembers | paginate: configPagerCommunityMembers">
      <td><a [routerLink]="['/network',item.nsId]">{{item.netIds | cidr}}</a></td>
      <td><a [routerLink]="['/network',item.nsId]">{{item.nsName}}</a></td>
      <td *ngIf="isAdmin">
        <ng-template #actionsPopup>
          <p class="popup-text" (click)="deleteModal.show()">Delete</p>
        </ng-template>
        <button class="view-detail-btn"
                [popover]="actionsPopup"
                placement="left"
                triggers="click"
                [outsideClick]="true"
                container="body">...</button>
          <app-delete-modal #deleteModal
                            text="Roaming Community Member {{item['name']}} will be deleted."
                            nsId="{{item['nsId']}}" roamingCommunityId="{{item['rcId']}}"
                            deleteType="roamingCommunityMember"></app-delete-modal>
      </td>
    </tr>
  </tbody>
</table>
<div class="noDataRow"
     *ngIf="!listCommunityMembers || listCommunityMembers.length === 0">There is no data available
</div>
<app-pagination-custom [config]="configPagerCommunityMembers"
                       (click)="refreshCommunityMembers()"></app-pagination-custom>
